import { render, staticRenderFns } from "./SecurityWarning.vue?vue&type=template&id=50250216&scoped=true"
import script from "./SecurityWarning.vue?vue&type=script&lang=js"
export * from "./SecurityWarning.vue?vue&type=script&lang=js"
import style0 from "./SecurityWarning.vue?vue&type=style&index=0&id=50250216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50250216",
  null
  
)

export default component.exports